/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JWTKeyResponse
 */
export interface JWTKeyResponse {
    /**
     * The unique key identifier (key ID) for the created JWT key
     * @type {string}
     * @memberof JWTKeyResponse
     */
    kid: string;
}

/**
 * Check if a given object implements the JWTKeyResponse interface.
 */
export function instanceOfJWTKeyResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kid" in value;

    return isInstance;
}

export function JWTKeyResponseFromJSON(json: any): JWTKeyResponse {
    return JWTKeyResponseFromJSONTyped(json, false);
}

export function JWTKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JWTKeyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kid': json['kid'],
    };
}

export function JWTKeyResponseToJSON(value?: JWTKeyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kid': value.kid,
    };
}

